import React from "react";
import Provider from "./Provider";
import { useLocation } from "react-router-dom";
import { Loader } from "../../services/helper";
import CustomTable from "../../components/CustomTable";
import DriverFormOne from "../../components/AllEditForms/DriverFormOne";
import Information from "./Information";

function AllDrivers() {
  const {
    driverInfo,
    alldriver,
    isLoading,
    handleActive,
    handleApprove,
    handleDelete,
    handleEdit,
    handleView,
    handlerefresh,
    fillAcconutStatus,
    fillProfileStatus,
    handleImage,
    handleAccount,
    handleProfile,
    fillStates,
    fillCities,
    handleState,
    handleCity,
    fullName,
    setFullName,
    mobile_number,
    setMobile_Number,
    preview,
    weight,
    setWeight,
    height,
    setHeight,
    blood_g,
    setBlood_g,
    experience,
    setExperience,
    dob,
    handleDOBChange,
    state,
    city,
    acc_status,
    pro_status,
    handleSubmitFormOne,
    errorsFormOne,
    openEdit,
    setOpenEdit,
    form,

    handleCarType,
    handleCarImages,
    carName,
    setCarname,
    carNo,
    setCarNo,
    carType,
    fillCarTypes,
    handleSubmitFormTwo,
    images,
    carInfoData,

    // Form Three
    handleDateChange,
    handleFileChange,
    handleRemovePreview,
    formValues,
    previews,
    handleSubmitFormThree,
    // Form Four
    fatherName,
    setFatherName,
    fatherNo,
    setFatherNo,
    emergencyNo,
    setEmergencyNo,
    relationName,
    setRelationName,
    relationType,
    handleRelationType,
    fillRelationsType,
    handleSubmitFormFour,
  } = Provider();

  const loc = useLocation().state;

  return (
    <>
      {isLoading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <CustomTable
            TableTitle={`All ${loc?.role} Information`}
            TableData={alldriver}
            handleActive={handleActive}
            handleApprove={handleApprove}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            role={loc?.role}
            handleView={handleView}
            data={driverInfo}
            handlerefresh={handlerefresh}
          />

          {driverInfo && openEdit && (
            <Information
              open={openEdit}
              close={setOpenEdit}
              data={driverInfo}
              handleApprove={handleApprove}
            />
          )}
          {/* <DriverFormOne
            form={form}
            open={openEdit}
            close={setOpenEdit}
            fullName={fullName}
            setFullName={setFullName}
            mobile_number={mobile_number}
            setMobile_Number={setMobile_Number}
            weight={weight}
            setWeight={setWeight}
            height={height}
            setHeight={setHeight}
            blood_g={blood_g}
            setBlood_g={setBlood_g}
            experience={experience}
            setExperience={setExperience}
            dob={dob}
            handleDOBChange={handleDOBChange}
            state={state}
            city={city}
            acc_status={acc_status}
            pro_status={pro_status}
            handleSubmitFormOne={handleSubmitFormOne}
            errorsFormOne={errorsFormOne}
            fillAcconutStatus={fillAcconutStatus}
            fillProfileStatus={fillProfileStatus}
            fillStates={fillStates}
            fillCities={fillCities}
            handleState={handleState}
            handleCity={handleCity}
            handleImage={handleImage}
            handleAccount={handleAccount}
            handleProfile={handleProfile}
            preview={preview}
            // Form Twoo
            handleCarType={handleCarType}
            handleCarImages={handleCarImages}
            images={carInfoData?.images}
            carName={carName}
            setCarname={setCarname}
            carNo={carNo}
            setCarNo={setCarNo}
            carType={carType}
            fillCarTypes={fillCarTypes}
            handleSubmitFormTwo={handleSubmitFormTwo}
            // Form Three
            handleDateChange={handleDateChange}
            handleFileChange={handleFileChange}
            handleRemovePreview={handleRemovePreview}
            formValues={formValues}
            previews={previews}
            handleSubmitFormThree={handleSubmitFormThree}
            // Form Four
            fatherName={fatherName}
            setFatherName={setFatherName}
            fatherNo={fatherNo}
            setFatherNo={setFatherNo}
            emergencyNo={emergencyNo}
            setEmergencyNo={setEmergencyNo}
            relationName={relationName}
            setRelationName={setRelationName}
            relationType={relationType}
            handleRelationType={handleRelationType}
            fillRelationsType={fillRelationsType}
            handleSubmitFormFour={handleSubmitFormFour}
          /> */}
        </>
      )}
    </>
  );
}

export default AllDrivers;
